
const arrayToLookupTable = function (array) {
  let obj = {};

  array.forEach(elem => {
    obj[elem.id] = elem;
  });

  return obj;
};

export { arrayToLookupTable };
